/**
 * @generated SignedSource<<0276079f593cbaaabd4b5751304df5ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedShopByModule_componentModule$data = {
  readonly cmsDisplayTitle: string | null;
  readonly items: ReadonlyArray<{
    readonly cmsId: number | null;
    readonly linkData: {
      readonly path: string | null;
    };
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedShopByModuleItem_item">;
  } | null> | null;
  readonly title: string | null;
  readonly " $fragmentType": "HpSharedShopByModule_componentModule";
};
export type HpSharedShopByModule_componentModule$key = {
  readonly " $data"?: HpSharedShopByModule_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedShopByModule_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedShopByModule_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cmsDisplayTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cmsId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedShopByModuleItem_item"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ShopByModule",
  "abstractKey": null
};

(node as any).hash = "10ee63e7e2eef0ce0cdcebcb8b6583bf";

export default node;
